import { ProcedureStepFieldValuesService as OvermapProcedureStepFieldValuesService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureStepFieldValuesService extends OvermapProcedureStepFieldValuesService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
